// Auto-generated index file for client logos
// This file exports all client logos for dynamic importing
// Run 'node scripts/generate-client-logos.js' to regenerate this file

import indospace from './indospace.svg';
import kempagowdaAirport from './kempagowda-airport.svg';
import mayaraRestaurant from './mayara-restaurant.svg';
import naamHospital from './naam-hospital.svg';
import olaElectric from './ola-electric.svg';
import snowField from './snow-field.svg';
import srmCollege from './srm-college.svg';
import vgSchool from './vg-school.svg';

export interface ClientLogo {
  src: string;
  alt: string;
}

// Export all client logos with their display names
export const clientLogos: ClientLogo[] = [
  { src: indospace, alt: 'Indospace' },
  { src: kempagowdaAirport, alt: 'Kempagowda Airport' },
  { src: mayaraRestaurant, alt: 'Mayara Restaurant' },
  { src: naamHospital, alt: 'Naam Hospital' },
  { src: olaElectric, alt: 'Ola Electric' },
  { src: snowField, alt: 'Snow Field' },
  { src: srmCollege, alt: 'Srm College' },
  { src: vgSchool, alt: 'Vg School' },
];
